/*
 * ---------------------------------------------------------------------------
 *
 * COPYRIGHT (c) 2023 IBS Software Canada Inc. All Rights Reserved.
 *
 * The copyright to the computer program(s) herein is the property of
 * IBS Software Canada Inc. The program(s) may be used and/or copied
 * only with the written permission from IBS Software Canada Inc.
 * or in accordance with the terms and conditions stipulated in the
 * agreement/contract under which the program(s) have been supplied.
 *
 * Date  : 2023-11-27
 *
 * ---------------------------------------------------------------------------
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  AuthorizationNotifier,
  DefaultCrypto,
  LocalStorageBackend,
  RedirectRequestHandler,
} from '@openid/appauth';
import { NoHashQueryStringUtils } from './noHashQueryStringUtils';

import { performTokenRequest, performAuthorizationRequest, clearLocalStorageFromTemporaryAuthRequest } from './oidcHelpers';
import { AUTHORIZATION_REQUEST_HANDLE_KEY, ACCESS_TOKEN, AUTHORIZATION_SUCCESS } from '../../data/constants';
import Logo from '../../components/Logo';

import actions from './../../data/login/actions';


async function completeAuthorizationRequest(authorizationHandler) {
  await authorizationHandler.completeAuthorizationRequestIfPossible().then(() => {
    clearLocalStorageFromTemporaryAuthRequest();
    if (!(sessionStorage.getItem(ACCESS_TOKEN) || sessionStorage.getItem(AUTHORIZATION_SUCCESS))) {
      console.log('access login redirect');
      window.location.href = '/login';
      window.location.reload();
    }
    sessionStorage.removeItem(AUTHORIZATION_SUCCESS);
  }).catch(() => {
    console.log('error occurred');
  });
}

class OIDC extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showSnackBar: false
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem(AUTHORIZATION_REQUEST_HANDLE_KEY)) {
      this.handleCallBack();
      return;
    }
    if (!sessionStorage.getItem(ACCESS_TOKEN)) {
      this.handleLogin();
      return;
    }
    this.props.redirect('/home');
  }

  componentDidUpdate() {

  }

  handleCallBack = () => {
    const authorizationHandler = new RedirectRequestHandler(new LocalStorageBackend(sessionStorage), new NoHashQueryStringUtils(), window.location, new DefaultCrypto());
    const notifier = new AuthorizationNotifier();
    authorizationHandler.setAuthorizationNotifier(notifier);
    notifier.setAuthorizationListener((request, response, error) => {
      console.log('Authorization request complete OIDC ', request, response, error);
      sessionStorage.setItem('Authorization_Success', true);
      if (response) {
        return performTokenRequest(response, request)
        .then(() => {
          console.log('token fetched');
          return this.props.fetchLoginOIDC();
        })
        .catch((oError) => {
          console.log('error occurred ', oError);
        });
      }
    });
    completeAuthorizationRequest(authorizationHandler);

  };

  handleLogin = () => {
    const authorizationHandler = new RedirectRequestHandler(new LocalStorageBackend(sessionStorage),
      new NoHashQueryStringUtils(), window.location, new DefaultCrypto());

    performAuthorizationRequest(authorizationHandler);
  }
  render() {
    return (
      <main className="Login">
        <section className="Login-Wrapper">
          <Logo />
        </section>
        <footer className="Login-Footer">
          <div>
            <figure>
              <img src="assets/img/IBS_Software_logo.png" alt="" />
            </figure>
          </div>
          <div className="Login-Footer-Disclaimer" />
        </footer>

      </main>
    );
  }

}
OIDC.defaultProps = {
  fetchLoginOIDC: function fetchLoginSSO() {},
  location: {},
  redirect: function redirect() {},
  error: {}
};

OIDC.propTypes = {
  fetchLoginOIDC: PropTypes.func,
  redirect: PropTypes.func.isRequired
};

const mapStateToProps = state => ({ ...state.login });

const mapDispatchToProps = dispatch => ({
  fetchLoginOIDC: () => dispatch(actions.fetchLoginOIDC()),
  redirect: path => dispatch(actions.redirect(path))
});

export default connect(mapStateToProps, mapDispatchToProps)(OIDC);
